import { render, staticRenderFns } from "./error.vue?vue&type=template&id=fe36f980"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EsMessage: require('/home/runner/work/flash-ui/flash-ui/components/EsMessage.vue').default})
